import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { TyNavMenuMap, TyRegionMessages } from '../../../../../types';
import NavMenu from './nav-menu';
import HeaderToolbar from './header-toolbar';
export default function Sidebar({
  menuMap,
  regionMessages,
  navToolbarMap
}: {
  menuMap: TyNavMenuMap;
  regionMessages: TyRegionMessages;
  navToolbarMap?: any;
}): JSX.Element {
  const sidebarRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    sidebarRef.current?.focus();
  }, []);

  
  useEffect(() => {
    const prevStyle = document.body.style;
    //need this DOM manipulation to stop body scrolling
    document.body.style = 'overflow:hidden';
    return () => {
      document.body.style = prevStyle;
    };
  }, []);

  useLayoutEffect(() => {
    const backgroundRegions = [
      document.querySelector<HTMLElement>('main#landing-page'),
      document.querySelector<HTMLElement>('footer'),
    ].filter((element): element is HTMLElement => Boolean(element));
    const previousAriaHidden = backgroundRegions.map(element => ({
      element,
      ariaHidden: element.getAttribute('aria-hidden'),
    }));

    backgroundRegions.forEach(element => element.setAttribute('aria-hidden', 'true'));

    return () => {
      previousAriaHidden.forEach(({ element, ariaHidden }) => {
        if (ariaHidden === null) {
          element.removeAttribute('aria-hidden');
        } else {
          element.setAttribute('aria-hidden', ariaHidden);
        }
      });
    };
  }, []);

  useEffect(() => {
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key !== 'Tab') return;

    const focusable = sidebarRef.current?.querySelectorAll(
      'a, button'
    );

    if (!focusable?.length) return;

    const first = focusable[0] as HTMLElement;
    const last = focusable[focusable.length - 1] as HTMLElement;

    if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus(); // Sign out -> Home
    }

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus(); // Home -> Sign out
    }
  };

  sidebarRef.current?.addEventListener('keydown', handleKeyDown);

  return () => {
    sidebarRef.current?.removeEventListener('keydown', handleKeyDown);
  };
}, []);

  return (
    <div
      ref={sidebarRef}
      className="fixed top-[70px] left-0 right-0 bottom-0 z-50 bg-black/75 overflow-y-auto"
      role="dialog"
      aria-modal="true"
      aria-label="Mobile navigation menu"
      tabIndex={-1}
    >
      <NavMenu navigationMap={menuMap} />
      <HeaderToolbar regionMessages={regionMessages} navToolbarMap={navToolbarMap}></HeaderToolbar>
    </div>
  );
}
